import React, { useState } from 'react';

import classes from './RestaurantCard.css'
import { ClassicSpinner } from '../Loader/ClassicSpinner';

const RestaurantCard = (props) => {
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  return (
    <div className={classes.Card} data-id={props.id} onClick={() => props.clicked(props.id, props.name)}>
      <div style={{ display: isLoading ? 'none' : 'block' }}>
        <img className={classes.CardImg} alt={props.name} src={props.imgSrc}
          onLoad={() => setIsLoading(false)} onError={() => setHasError(true)} />
      </div>
      {hasError && <p style={{ textAlign: 'center', margin: 0 }} className={classes.LoadingContainer}>{props.name}</p>}
      {isLoading && !hasError &&
        <div className={classes.LoadingContainer}>
          <ClassicSpinner />
        </div>}
    </div>
  );
}
export default RestaurantCard;



// WEBPACK FOOTER //
// ./src/components/UI/RestaurantCard/RestaurantCard.js